import React from 'react';
import { Link, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './Dashboard.scss';
import Loading from '../../components/Loading/Loading';
import Nav from './Nav/Nav';
const EditorSecciones = React.lazy(() => import('./EditorSeccions/EditorSeccions'));
const EditorCalendari = React.lazy(() => import('./EditorCalendari/EditorCalendari'));
const EditorContenido = React.lazy(() => import('./EditorContingut/EditorContingut'));

enum Accent {
  BLUE = '#0b57d0',
  XICS = '#721b2b',
  GREEN = '#91D6AC',
  BAIX = '#0f5766',
  MANYACS = '#54397E',
  CALDES = '#1e4c44',
  VERDS = '#009c8b',
  CVXV = '#f08080',
  CJXV = '#ff0000',
  CJXT = '#c8a2c8',
  OSONA = '#ffa500'
}

const DashboardContext = React.createContext({
  accent: Accent.BLUE,
});

export { DashboardContext };

export default class DashboardRoutes extends React.Component {

  componentDidMount(): void {
    const cookies = this.getCookies();
    const accent = cookies['accent'];
    if (accent && Object.values(Accent).includes(accent as Accent)) {
      document.documentElement.style.setProperty('--accent-color', accent);
    }
  }

  getCookies(): { [key: string]: string } {
    const cookies = document.cookie.split('; ');
    const cookieObj: { [key: string]: string } = {};
    cookies.forEach(cookie => {
      const [name, value] = cookie.split('=');
      cookieObj[name] = value;
    });
    return cookieObj;
  }

  render(): React.ReactNode {
    return (
      <DashboardContext.Provider value={{
        accent: Accent.BLUE,
      }}>
        <Router>
          <Nav />
          <main className='dash'>
            <Routes>
              <Route path='/' element={
                <React.Suspense fallback={<Loading />}>
                  <div className='home'>
                    <ul>
                      <li>
                        <Link to='/calendari'>
                          <h2>Calendari</h2>
                          <p>Modifica, crea o elimina esdeveniments al calendari anual.</p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </React.Suspense>
              } />
              <Route path='/calendari' element={
                <React.Suspense fallback={<Loading />}>
                  <EditorCalendari />
                </React.Suspense>
              } />
              <Route path='/noticies' element={
                <React.Suspense fallback={<Loading />}>
                  <EditorContenido />
                </React.Suspense>
              } />
              <Route path='/secciones' element={
                <React.Suspense fallback={<Loading />}>
                  <EditorSecciones />
                </React.Suspense>
              } />
            </Routes>
          </main>
        </Router>
      </DashboardContext.Provider>
    );
  }
}